'use client';

import React, { createContext, useContext } from 'react';
import { DataroomTenant } from './DataroomTenant';
import { IDataroomTenantContext, DataroomTenantContextSymbol } from './types';
import { getContainer } from '@framework/di/getContainer';

const DataroomTenantContext = createContext<IDataroomTenantContext | null>(null);

export const useDataroomTenantContext = (): IDataroomTenantContext => {
  const context = useContext(DataroomTenantContext);
  if (!context) {
    throw new Error('useDataroomTenantContext must be used within a DataroomTenantContextProvider');
  }
  return context;
};

interface IProps {
  children: React.ReactNode,
  tenant: DataroomTenant,
}

function DataroomTenantContextProvider({ tenant, children }: IProps) {
  const container = getContainer();
  const contextValue = { tenant };

  container.bindContextValue(DataroomTenantContextSymbol, contextValue, true);

  return (
    <DataroomTenantContext.Provider value={ contextValue }>
      { children }
    </DataroomTenantContext.Provider>
  );
}

export default DataroomTenantContextProvider;
